import { Fragment, FC } from "react";

const User: FC<{ color: string }> = ({ color = "white" }) => {
  return (
    <Fragment>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 15.5942C14.35 15.5942 13 15.0531 11.95 13.971C10.9 12.8889 10.375 11.4976 10.375 9.7971C10.375 8.09662 10.9 6.70531 11.95 5.62319C13 4.54106 14.35 4 16 4C17.65 4 19 4.54106 20.05 5.62319C21.1 6.70531 21.625 8.09662 21.625 9.7971C21.625 11.4976 21.1 12.8889 20.05 13.971C19 15.0531 17.65 15.5942 16 15.5942ZM4 28V24.3671C4 23.3881 4.2375 22.5507 4.7125 21.8551C5.1875 21.1594 5.8 20.6312 6.55 20.2705C8.225 19.4976 9.83125 18.9179 11.3688 18.5314C12.9062 18.1449 14.45 17.9517 16 17.9517C17.55 17.9517 19.0875 18.1514 20.6125 18.5507C22.1375 18.9501 23.7375 19.5233 25.4125 20.2705C26.1875 20.6312 26.8125 21.1594 27.2875 21.8551C27.7625 22.5507 28 23.3881 28 24.3671V28H4Z"
          fill={color}
        />
      </svg>
    </Fragment>
  );
};

export default User;
